import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import {
    BASE,
    URLS,
    APIS,
    SF_DOC_RCPN_MGMT_INFO
} from "@/tra/tancis/ptli/elctdoc/hist/services/PtliDocHistService";
import { PTLI0701003Q } from "@/tra/tancis/ptli/elctdoc/rcpn/PTLI0701003Q";

/*
 * Interface History details
 * !== 인터페이스 이력 상세정보 ==!
 */
export const PTLI0707002Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0019"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const modal = useModal();
    const { trscLogId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        docRcpnMgmtInfo: useForm({
            defaultSchema: SF_DOC_RCPN_MGMT_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const fetch = {
        // Gets Interface information. !== 인터페이스 정보를 조회한다.==!
        getIntfHist: useFetch({
            api: () => APIS.getIntfHist(trscLogId),
            enabled: !!trscLogId,
            onSuccess: (data) => {
                const intfHistInfo = data?.intfHistInfo?.content;

                form.docRcpnMgmtInfo.setValues(intfHistInfo);
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {
                            navigate(URLS.ptli0707001q);
                        },
                        close: false
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.com.00018" }) // An error occurred. !== 에러가 발생했습니다! ==!
            }
        }),
    };

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getIntfHist.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.trscLogId}></Group.Control>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.intfId}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.trscId}></Group.Control>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.intfSndrId}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.intfRcvrId}></Group.Control>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.coReffNo}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.ucrNo}></Group.Control>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.intfSttsCdNm}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docRcpnMgmtInfo.schema.frstRgsrDtm}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control 
                                {...form.docRcpnMgmtInfo.schema.intfRsltErrCn}
                                controlSize={10}
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control 
                                {...form.docRcpnMgmtInfo.schema.htphdCn}
                                controlSize={10}
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control 
                                {...form.docRcpnMgmtInfo.schema.msgOrgnCn}
                                controlSize={10}
                                label={
                                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                        {t("L_MSG_ORGN_CN")} 
                                        <Button 
                                            role="search" 
                                            style={{display: "inline-block"}}
                                            onClick={() => {
                                                const msg = form.docRcpnMgmtInfo.getValue("msgOrgnCn");

                                                if(comnUtils.isEmpty(msg)) return;

                                                const modalCallback = () => {
                                                    modal.closeModal();
                                                };
                                        
                                                modal.openModal({
                                                    draggable: true,
                                                    size: "md",
                                                    content: (
                                                        <PTLI0701003Q
                                                            callback={modalCallback}
                                                            msg={msg}
                                                        />
                                                    ),
                                                });
                                            }}
                                        >
                                        Beautify
                                        </Button>
                                    </div>
                                }
                            ></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control 
                                {...form.docRcpnMgmtInfo.schema.msgAckCn}
                                controlSize={10}
                                label={
                                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%"}}>
                                        {t("L_MSG_ACK_CN")} 
                                        <Button 
                                            role="search" 
                                            style={{display: "inline-block"}}
                                            onClick={() => {
                                                const msg = form.docRcpnMgmtInfo.getValue("msgAckCn");

                                                if(comnUtils.isEmpty(msg)) return;

                                                const modalCallback = () => {
                                                    modal.closeModal();
                                                };
                                        
                                                modal.openModal({
                                                    draggable: true,
                                                    size: "md",
                                                    content: (
                                                        <PTLI0701003Q
                                                            callback={modalCallback}
                                                            msg={msg}
                                                        />
                                                    ),
                                                });
                                            }}
                                        >
                                        Beautify
                                        </Button>
                                    </div>
                                }
                            ></Group.Control>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button
                                role="list"
                                onClick={() => {
                                    navigate(URLS.ptli0707001q);
                                }}
                            ></Button>
                        </Layout.Left>
                    </Layout>
                </Group.Body>
            </Group>
        </Page>
    );
};
